import { useEffect } from 'react';

export const useFocusOnMount = (query: string, options?: { preventScroll?: boolean }) => {
    useEffect(() => {
        const timeout = setTimeout(() => {
            const element = document.querySelector(query) as HTMLInputElement;
            if (element) {
                element.focus({ preventScroll: options?.preventScroll });
            }
        }, 100);
        return () => clearTimeout(timeout);
    }, []);
};
